"use client";
import { jsx } from "react/jsx-runtime";
import { Checkbox } from "@nxt-costco-com/forge-components";
import { addToListActions } from "../../constants.js";
const ListCheckBox = ({
  selectedLists,
  wishListValue,
  wishListText,
  dispatch
}) => {
  return /* @__PURE__ */ jsx(
    Checkbox,
    {
      isChecked: selectedLists.find((list) => list.value === wishListValue) ? true : false,
      onChange: (_e, checked) => {
        const isInList = selectedLists.find(
          (list) => list.value === wishListValue
        );
        if (isInList && !checked) {
          const newSelectedLists = selectedLists.filter(
            (listItem) => listItem.value !== wishListValue
          );
          dispatch({
            payload: {
              errorMsg: "",
              globalErrorMsg: "",
              globalSuccessMsg: "",
              selectedLists: [...newSelectedLists],
              successMsg: ""
            },
            type: addToListActions.UPDATE_STATE
          });
        } else if (checked) {
          dispatch({
            payload: {
              errorMsg: "",
              globalErrorMsg: "",
              globalSuccessMsg: "",
              selectedLists: [
                ...selectedLists,
                { text: wishListText, value: wishListValue }
              ],
              successMsg: ""
            },
            type: addToListActions.UPDATE_STATE
          });
        }
      },
      id: wishListValue,
      label: wishListText
    }
  );
};
export {
  ListCheckBox
};
